module.exports = __webpack_public_path__ + "img/noise_On.f031e1ee.png";